export default {
  appId: 32145,
  appName: '兔宝宝',
  appIcon: 'http://pics.tutuapp.com/picture/app_ios/us/2020/05/14/17/x4cjbeeqhpsu.jpeg',
  developer: 'tencent',
  language: '英文 中文',
  category: '游戏',
  tag: '角标1 角标2',
  platform: 'iOS',
  appDesc: '应用描述大萨达撒大大多',
  version: 'v2.1.2',
  editDesc: '编辑介绍哒哒哒哒所多',
  filePath: '下载地址2131231',
  screenShot: ['http://pics.tutuapp.com/picture/app_ios/us/2020/05/14/17/x4cjbeeqhpsu.jpeg', 'http://pics.tutuapp.com//picture/app_ios/cn/003/62/84/15/3628415.175x175-75.jpg'],
  commitList: [
    // 按提交时间排序
    {
      user: 'huhua',
      commitTitle: '提交审核',
      commitTime: '2020/05/01 13:22:22',
      commitResult: '审核不通过',
      confirmTime: '2020/05/01 14:23:10'
    },
    {
      user: 'huhua',
      commitTitle: '第二次提交审核',
      commitTime: '2020/05/02 13:22:22',
      commitResult: '审核通过',
      confirmTime: '2020/05/03 14:23:10'
    }
  ]
}
